import { useEffect, useState } from "react"
import { StepProps } from "../../../../components/Stepper"
import { useRequest } from "../../../../hooks/useRequest"
import { BuyData } from "../../../../types/steps/buy"
import { Excellent } from "../../../../components/svgCollection"

const BODY = "'Manrope', sans-serif"
const MONO = "'JetBrains Mono', monospace"

export default function CancelStatus({ params, goBack }: StepProps<BuyData>) {
    const { request } = useRequest()
    const [cancelled, setCancelled] = useState(false)

    useEffect(() => {
        let intervalId: number

        const checkOrderExists = async () => {
            const orders = await request("GET", "user/order")
            const hasOrder = Array.isArray(orders) && orders.some((order: { id?: string }) => order.id === params.orderId)
            if (!hasOrder) {
                setCancelled(true)
                clearInterval(intervalId)
            }
        }

        checkOrderExists()
        intervalId = window.setInterval(checkOrderExists, 5000)

        return () => clearInterval(intervalId)
    }, [params.orderId])

    return (
        <div className="flex h-full min-h-0 flex-1 flex-col px-5 py-8 pb-[max(2rem,var(--safe-bottom))]">
            {cancelled ? (
                <>
                    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-1 text-center">
                        <Excellent />
                        <div className="text-[20px] leading-snug text-white md:text-[22px]" style={{ fontFamily: BODY, fontWeight: 700 }}>
                            Билет успешно отменён
                        </div>
                        <div className="max-w-[320px] text-[14px] leading-relaxed text-white/50 md:text-[15px]" style={{ fontFamily: BODY, fontWeight: 500 }}>
                            Срок возврата средств:
                            <br />— Банковская карта: до 10 банковских дней
                            <br />— СБП: до 24 часов
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={goBack}
                        className="mt-2 h-[50px] w-full shrink-0 cursor-pointer rounded-[14px] text-[16px] text-white"
                        style={{
                            background: "#349be6",
                            fontFamily: MONO,
                            fontWeight: 700,
                            boxShadow: "0 0 18px rgba(52,155,230,0.35)",
                        }}>
                        Хорошо
                    </button>
                </>
            ) : (
                <div className="flex flex-1 flex-col items-center justify-center gap-5 px-1 text-center">
                    <img src={require("../../../../assets/pop-corn.gif")} alt="" className="size-[72px] object-contain opacity-90" />
                    <div className="text-[20px] leading-snug text-white md:text-[22px]" style={{ fontFamily: BODY, fontWeight: 700 }}>
                        Отменяем билет...
                    </div>
                    <div className="max-w-[320px] text-[14px] leading-relaxed text-white/50 md:text-[15px]" style={{ fontFamily: BODY, fontWeight: 500 }}>
                        Это может занять некоторое время.
                        <br />
                        Пожалуйста, не закрывайте страницу
                    </div>
                </div>
            )}
        </div>
    )
}
